import { Component, Input } from '@angular/core';

@Component({
  selector: 'campaign-list',
  template: require('../templates/campaign-list.component.html'),
  styles: [require('../styles/main.scss'),
              require('../styles/campaign-list.component.scss')]
})
export class CampaignListComponent {
  @Input() campaign_list: any[]=[];

  constructor() { }

  getProgressValue(campaign: {}) {
    var progress_value: number;
    progress_value = campaign['donation_total'] / campaign['goal'] * 100;
    return progress_value + '%'
  }

  getCampaignPic(campaign: {}, id=false, alt=false) {
    if(campaign['profile_pic'] && campaign['profile_pic']['url']){
      if(id) {
        return campaign['profile_pic']['media_id'];
      }
      if(alt) {
        return campaign['profile_pic']['filename'];
      }
      return campaign['profile_pic']['url'];
    }
    else if(campaign['media'] && campaign['media'].length > 0) {
      if(id) {
        return campaign['media'][0]['media_id'];
      }
      if(alt) {
        return campaign['media'][0]['filename'];
      }
      return campaign['media'][0]['url'];
    }
    else {
      if(id) {
        return '';
      }
      if(alt) {
        return 'no-file';
      }
      return 'https://unsplash.it/325/230/?random';
    }
  }

  goToCampaign(campaign: {}) {
    var networkurl: any;
    networkurl = "/campaign/" + campaign['slug'];
    window.location.href = networkurl;
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./app/components/campaign-list.component.ts